import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { filterProps } from 'foundations-components/utils/filterProps';
import styled from 'styled-components';

// We can add to this over time as necessary, these are just the most used trellis prop sets
import { jsx as _jsx } from "react/jsx-runtime";
const WithCssStyles = styled.div.withConfig({
  displayName: "AssetSection__WithCssStyles",
  componentId: "sc-1kvkz49-0"
})(props => Object.assign({}, props.$cssStyles));
const CustomFlex = styled(WithCssStyles).attrs({
  'data-test-id': 'asset-section'
})(({
  theme
}) => `
  display: flex;
  flex-direction: column;
  gap: ${theme.space['500']};
  margin: ${theme.space['0']};

  :empty {
    display: none;
  }
`);
export default function AssetSection(props) {
  const {
    domProps,
    tokenProps,
    callbackProps
  } = filterProps(props);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(CustomFlex, Object.assign({
    as: props.as || 'section',
    "data-test-id": "asset-section"
  }, props, domProps, callbackProps, {
    $cssStyles: cssStyles
  }));
}